import { Grid, Table, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { ExpensesFilterFormPaginated } from 'features/expenses-report/component/expenses-filter-form';
import { FieldsResponse } from 'features/fields';
import { usePermissions } from 'features/users';
import { Dispatch, SetStateAction } from 'react';
import { Field } from 'types';
const { useBreakpoint } = Grid;

type FieldsTableProps = {
  isLoading: boolean;
  data?: FieldsResponse;
  tableParams: ExpensesFilterFormPaginated;
  updateParams: Dispatch<SetStateAction<ExpensesFilterFormPaginated>>;
  setEditModal: any;
  setEditdata: any;
};

export const ExpensesTable = ({
  data,
  isLoading,
  tableParams,
  updateParams,
  setEditModal,
  setEditdata,
}: FieldsTableProps) => {
  const screens = useBreakpoint();
  const permissions = usePermissions();

  if (!permissions) return null;

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<Field> | SorterResult<Field>[],
  ) => {
    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
        ? 'name'
        : '-name',
    });
  };

  const tableWidth = screens.xxl ? { x: 1440 } : { x: 1200 };

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge text={'Expenses Charge'} count={data?.total || 0} />
      </StyledTableHeader>
      <Table
        loading={isLoading}
        dataSource={data?.items}
        rowKey='id'
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: data?.total,
        }}
        scroll={tableWidth}
        onRow={(record) => ({
          onClick: () => {
            setEditModal(true);
            setEditdata(record);
          },
        })}
      >
        <Column
          title={'Facility Name'}
          dataIndex={'FacilityName'}
          width={screens.xxl ? 'auto' : 240}
          ellipsis
        />
        <Column<Field>
          title={'FieldName'}
          dataIndex={'FieldName'}
          width={screens.xxl ? 'auto' : 240}
          ellipsis
        />
        <Column<Field>
          title={'Sport Name'}
          dataIndex={'SportName'}
          width={screens.xxl ? 'auto' : 240}
          ellipsis
        />
        <Column<Field>
          title={'Total amount'}
          dataIndex={'TotalAmount'}
          width={screens.xxl ? 'auto' : 200}
          className='cell-direction-rtl'
          ellipsis
        />
      </Table>
    </StyledTableWrapper>
  );
};
